import React from 'react'

import NotificationContent from 'components/notifications/molecules/NotificationContent'
import HeaderWrapper from 'components/newHeader/HeaderWrapper'
import HeaderCustom from 'components/newHeader/HeaderCustom'
import { func } from 'prop-types'

const NotificationPopup = ({ close }) => (
  <div className="notification-popup">
    <HeaderWrapper>
      <HeaderCustom title="Notifikasi" close={close} />
    </HeaderWrapper>
    <div className="notification-popup__wrapper">
      <NotificationContent />
    </div>
    <style jsx>
      {`
        .notification-popup {
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 100;
          top: 0;
          right: 0;
          &__wrapper {
            position: fixed;
            min-height: calc(100vh - 64px);
            width: 100%;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 98;
            padding: 64px 0 0;
            overflow: hidden auto;
            background-color: #fff;
          }
          @media screen and (min-width: 768px) {
            display: none;
          }
        }
      `}
    </style>
  </div>
)

NotificationPopup.propTypes = {
  close: func,
}

export default NotificationPopup
